import { isAdmin } from "./NavigationUtils";

export const primaryButtonClassName = (): string => {
  return isAdmin ? "admin-button" : "primary-button";
};

export const subButtonClassName = (): string => {
  return isAdmin ? "admin-sub-button" : "sub-button";
};
